export default function protocolReducer(protocol, action) {
  switch (action.type) {
    case "SET_PROTOCOL_ID":
      return { ...protocol, protocolId: action.payload };
    case "SET_LAST_SAVED":
      return { ...protocol, lastSaved: action.payload };
    case "SET_PROTOCOL_LAST_SAVED":
      return { ...protocol, protocolLastSaved: action.payload };
    case "SET_CHANGES_JSON":
      return { ...protocol, changesJSON: action.payload };
    case "SET_DATE_OFFSET":
      return { ...protocol, dateOffset: action.payload };
    case "SET_TIME_SHIFT":
      return { ...protocol, timeShift: action.payload };
    default:
      return protocol;
  }
}
